<div class="modal-header">
  <h4 class="modal-title">
    Import Events
  </h4>
  <button class="btn btn-link text-secondary" aria-label="Close" (click)="modal.dismiss('Cross click')">
    <fa-icon [icon]="faTimes"></fa-icon>
  </button>
</div>
<form [formGroup]="form" autocomplete="off" novalidate>
  <div class="modal-body">
    <div class="col-12">
      <div class="card py-3">
        <div class="col-12">
          <div class="form-row">
            <div class="form-group col-4">
              <label for="date">Upload File: </label>
              <div class="input-group">
                <input type="file" accept=".xlsx,.xls" #fileInput (change)="processExcel($event)">
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--display each row of event after it's parsed from excel sheet for user confirmation before processing-->
      @if (adminEvents.length > 0) {
        <div class="py-3">
          <br />
          <label for="date">Events to process:</label>
          <br />
          <div style="width: 100%;">
            <ag-grid-angular style="width: 100%; height: 35vh;"
              class="ag-theme-quartz"
              [rowData]="adminEvents"
              [columnDefs]="columnDefs"
              [gridOptions]="gridOptions">
            </ag-grid-angular>
          </div>
        </div>
      }
      @if (adminEvents.length === 0) {
        <div class="py-3">
          <br />
          <label style="margin-left: 1%;"> No events to process. Please upload a valid excel sheet to begin.</label>
        </div>
      }
    </div>
  </div>
</form>

<div class="modal-footer">
  <button type="button" class="btn" [ngClass]="{ 'btn-outline-secondary': adminEvents.length === 0, 'btn-success': adminEvents.length > 0 }" [disabled]="adminEvents.length === 0" (click)="submitImportedEvents()">
    Process
  </button>
</div>
